import { useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';

import { Accordion, useAccordionState, useTracking } from '@anwb/poncho/components/accordion';
import List from '@anwb/poncho/components/list';
import Tooltip from '@anwb/poncho/components/tooltip';
import { trackEvent } from '@anwb/poncho/utilities/tracking';
import { useGaFunnelInfo } from 'hooks/useGaFunnelInfo';
import { leaseCarOptionsSelector, standardEquipmentSelector } from 'store/selectors';

import { StandardEquipmentContainer } from '../styles/standardEquipment.styled';
import { getPreInstalledForOccasion } from '../utils';

export const StandardEquipment = () => {
	const standardEquipmentList = useSelector(standardEquipmentSelector);
	const options = useSelector(leaseCarOptionsSelector);
	const preInstalled = getPreInstalledForOccasion(options);
	const ref = useRef(null);
	const track = useTracking({ ref, reference: 'occasion-equipment' });
	const { isOpenStates, toggle } = useAccordionState({
		initialState: [false],
		onChange: track,
	});
	const gaFunnelInfo = useGaFunnelInfo();

	if (!standardEquipmentList && !preInstalled.length) {
		return null;
	}

	const handleToggle = () => {
		if (!isOpenStates[0]) {
			trackEvent({
				event: 'user_interaction',
				type: 'form',
				component: 'accordion',
				field: 'Standaarduitrusting',
				action: 'click',
				actionValue: 'open',
				...gaFunnelInfo,
			});
		}

		toggle(0);
	};

	return (
		<StandardEquipmentContainer>
			<Accordion>
				<Accordion.Item isOpen={isOpenStates[0]} toggle={handleToggle}>
					<Accordion.Header>
						<Accordion.Title>Standaarduitrusting</Accordion.Title>
					</Accordion.Header>
					<Accordion.Content>
						<Accordion.Body>
							<List variant="bulleted">
								{preInstalled.map((option) => (
									<List.Item key={option.id}>
										{option.description}
										{option.optionContent && (
											<Tooltip>
												<ReactMarkdown>{option.optionContent}</ReactMarkdown>
											</Tooltip>
										)}
									</List.Item>
								))}
								{standardEquipmentList &&
									standardEquipmentList.map((option) => (
										<List.Item key={option.name}>{option.descriptions}</List.Item>
									))}
							</List>
						</Accordion.Body>
					</Accordion.Content>
				</Accordion.Item>
			</Accordion>
		</StandardEquipmentContainer>
	);
};
